export default "__VITE_ASSET__DuGWCjy0__"